import type { PortRange } from '#dn-types/role.ts';

/**
 * Converts a ports string which may or may not be pre-validated into an object
 * with from and to.  A value of `NaN` indicates an invalid ports format
 */
export function parsePorts(ports: string): PortRange | null {
  if (ports.trim() === '' || ports.trim().toLowerCase() === 'any') {
    return null;
  }

  if (ports.includes('-')) {
    const [from, to, ...rest] = ports.split('-');

    // Check for multiple dashes
    if (rest.length) {
      return {
        from: Number.NaN,
        to: Number.NaN,
      };
    }

    return {
      from: Number(isValidNumber(from) ? from : 'NaN'),
      to: Number(isValidNumber(to) ? to : 'NaN'),
    };
  }

  return {
    from: Number(isValidNumber(ports) ? ports : 'NaN'),
    to: Number(isValidNumber(ports) ? ports : 'NaN'),
  };
}

/**
 * Checks whether the provided string is a valid number (basically a strict integer).
 */
function isValidNumber(num?: string) {
  return num && num.trim() !== '' && Number.isInteger(Number(num)) && String(Number(num)) === num.trim();
}
